module.exports = __webpack_public_path__ + "img/icon-nossa-visão-7c8a0c16.png";